import { FlagListData } from '@modules/HappinessModule/interfaces/FlagListData';
import { createAction } from '@reduxjs/toolkit';
import { AsyncData } from 'shared/interfaces/asyncData';

export const getMyTeamFlagsData = createAction<void>('myTeamFlags/getMyTeamFlagsData');
export const setMyTeamFlagsData = createAction<AsyncData<FlagListData[]>>('myTeamFlags/setMyTeamFlagsData');
